import { useCallback, useEffect } from "react";
import useLocalState from "../useLocalState";
// TODO: AA - this is a temporary solution to refactor to chatId from threadId
var createID = function () { return "".concat(Date.now(), "-").concat(Math.random()); };
var useThread = function () {
    var oldThreadId = useLocalState("thread-id", null)[0];
    var _a = useLocalState("chat-id", createID()), chatId = _a[0], setChatId = _a[1];
    // Migrate from thread-id to chat-id
    useEffect(function () {
        if (oldThreadId) {
            setChatId(oldThreadId);
            localStorage.removeItem("thread-id");
        }
    }, [oldThreadId, setChatId]);
    var resetThread = useCallback(function () {
        setChatId(createID());
        localStorage.removeItem("thread-id");
    }, [setChatId]);
    return { chatId: chatId, resetThread: resetThread, setChatId: setChatId };
};
export default useThread;
